import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { policyOwnerAction } from '../../../actions/policyOwnerAction';
import './PolicyOwner.css';
import CommonFormHeader from '../../commonFormHeader';
import FormFieldsWrapper from '../../ui/formFieldsWrapper';
import LabelRadioButtons from '../../ui/labelRadioButtons';
import CommonLabelRadioButtons from '../../ui/commonLabelRadioButton';
import IndividualSection from './individualSection';
import TrustSection from './trustSection';
import LlcSection from './llcSection';
import CompanySection from './companySection';
import PartnershipSection from './partnershipSection';
import Loader from '../../loader';
import axios from '../../../axios/axios';
import ToastMessage from '../../ui/toastMessage';
import { SET_SEND_DATA } from '../../../constants/sendDataConstants';
import { pageNavigationAction } from '../../../actions/pageNavigationAction';
import { TOAST_MESSAGE_TIME } from '../../../constants/toastMessageConstants';

const PolicyOwner = () => {
  const hideFields = 'no';
  const [poQuestion, setPoQuestion] = useState({});

  const [llcData, setLlcData] = useState({});
  const [individualPhoneList, setIndividualPhoneList] = useState([]);
  const [individualEmailList, setIndividualEmailList] = useState([]);
  const [individualRelationship, setIndividualRelationship] = useState(null);
  const [individualTitle, setIndividualTitle] = useState('');
  const [individualFirstName, setIndividualFirstName] = useState('');
  const [individualMiddleName, setIndividualMiddleName] = useState('');
  const [individualLastName, setIndividualLastName] = useState('');
  const [individualSuffix, setIndividualSuffix] = useState('');
  const [individualDOB, setIndividualDOB] = useState('');
  const [individualSSN, setIndividualSSN] = useState('');
  const [individualBirthPlace, setIndividualBirthPlace] = useState('');
  const [individualGender, setIndividualGender] = useState(null);
  const [spouseFirstname, setSpouseFirstname] = useState('');
  const [spouseMiddleName, setSpouseMiddleName] = useState('');
  const [spouseLastName, setSpouseLastName] = useState('');
  const [spouseDOB, setSpouseDOB] = useState('');
  const [spouseSSN, setSpouseSSN] = useState('');
  const [individualaddressSection, setIndividualaddressSection] = useState([]);
  const [individualDriverLicenseFields, setIndividualDriverLicenseFields] =
    useState({});
  const [noOptionValue, setOptionValue] = useState({});
  const [entityOptionValue, setEntityOptionValue] = useState({});
  const [trustAgreementFields, setTrustAgreementFields] = useState({});
  const [companyNameSection, setCompanyNameSection] = useState({});
  const [companyAuthorizedFields, setCompanyAuthorizedFields] = useState({});
  const [companyAddressFields, setCompanyAddressFields] = useState({});
  const [companyContactDetailsFields, setCompanyContactDetailsFields] =
    useState({});
  const [companyPhoneFields, setCompanyPhoneFields] = useState([]);
  const [partnershipSectionFields, setPartnershipSectionFields] = useState({});
  const [partnershipAddressFields, setPartnershipAddressFields] = useState({});
  const [partnershipContactDetailsFields, setPartnershipContactDetailsFields] =
    useState({});
  const [trustName, setTrustName] = useState({});
  const [partners, setPartners] = useState([]);
  const [trustee, setTrustee] = useState([]);
  const [beneficiary, setBeneficiary] = useState([]);
  const [trustType, setTrustType] = useState();
  const [toastMessage, showToastMessage] = useState(false);
  const [showDataSaveLoader, setShowDataSaveLoader] = useState(false);
  const [trustAgreementYesValue, setTrustAgreementYesValue] = useState('');
  const dispatch = useDispatch();
  const fieldData = useSelector((state) => state.policyOwnerData);
  const { loading, error, poData } = fieldData;

  useEffect(() => {
    dispatch(policyOwnerAction());
  }, [dispatch]);

  const questionSectionData = poData?.data?.questionSection;
  const noOptions = poData?.data?.noQuestion.options;
  const entityOptions = poData?.data?.entityQuestion.options;

  useEffect(() => {
    const initialPoValue = poData?.data?.questionSection?.options?.find(
      (item) => item.defaultChecked
    );
    if (initialPoValue) {
      const key = initialPoValue['id'];
      const value = initialPoValue['value'];
      setPoQuestion({ [key]: value });
    }
    const initialNoValue = poData?.data?.noQuestion?.options.find(
      (item) => item.defaultChecked
    );
    if (initialNoValue) {
      const key = initialNoValue['id'];
      const value = initialNoValue['value'];
      setOptionValue({ [key]: value });
    }
    const initialEntityValue = poData?.data?.entityQuestion?.options?.find(
      (item) => item.defaultChecked
    );
    if (initialEntityValue) {
      const key = initialEntityValue['id'];
      const value = initialEntityValue['value'];
      setEntityOptionValue({ [key]: value });
    }
    const initialTrustAgreementValue =
      poData?.data?.trustAgreementSection?.options?.find(
        (item) => item.defaultChecked
      );
    if (initialTrustAgreementValue) {
      const key = initialTrustAgreementValue['id'];
      const value = initialTrustAgreementValue['value'];
      setTrustAgreementFields({ [key]: value });
    }

    setIndividualRelationship(poData?.data?.insuredRelationship?.value);
    setIndividualPhoneList(poData?.data?.individualAddPhone);
    setIndividualEmailList(poData?.data?.individualAddEmail);
    setIndividualaddressSection(poData?.data?.individualaddressSection);
    setPartners(poData?.data?.partnerInfo);
    setCompanyPhoneFields(poData?.data?.companyPhoneFields);
    if (poData?.data?.trusteeSection !== undefined) {
      setTrustee(poData?.data?.trusteeSection);
    }
    if (poData?.data?.beneficiaryFields !== undefined) {
      setBeneficiary(poData?.data?.beneficiaryFields);
    }
    setTrustAgreementYesValue(poData?.data?.trustAgreementYesOptions?.value);
  }, [poData?.data]);

  const poQuestionChangeHandler = (event) => {
    const initNoValue = poData?.data?.noQuestion?.options.find(
      (item) => item.defaultChecked
    );
    if (initNoValue) {
      const key = initNoValue['id'];
      const value = initNoValue['value'];
      setOptionValue({ [key]: value });
    }
    const initEntityValue = poData?.data?.entityQuestion?.options?.find(
      (item) => item.defaultChecked
    );
    if (initEntityValue) {
      const key = initEntityValue['id'];
      const value = initEntityValue['value'];
      setEntityOptionValue({ [key]: value });
    }
    setPoQuestion(() => ({
      [event.target.id]: event.target.value,
    }));
  };

  const noOptionsChangeHandler = (event) => {
    const initialEntityValue = poData?.data?.entityQuestion?.options?.find(
      (item) => item.defaultChecked
    );
    if (initialEntityValue) {
      const key = initialEntityValue['id'];
      const value = initialEntityValue['value'];
      setEntityOptionValue({ [key]: value });
    }
    setOptionValue(() => ({
      [event.target.id]: event.target.value,
    }));
  };

  const entityChangeHandler = (event) => {
    const initialEntityValue = poData?.data?.entityQuestion?.options?.find(
      (item) => item.defaultChecked
    );
    if (initialEntityValue) {
      const key = initialEntityValue['id'];
      const value = initialEntityValue['value'];
      setEntityOptionValue({ [key]: value });
    }
    setEntityOptionValue(() => ({
      [event.target.id]: event.target.value,
    }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      showToastMessage(false);
    }, TOAST_MESSAGE_TIME);
    return () => clearTimeout(timer);
  }, [toastMessage]);

  const payload = {
    questionSection: poQuestion,
    noQuestion: noOptionValue,
    insuredRelationship: {
      'individual-relationshipToTheInsured': individualRelationship,
    },
    individualTitle: individualTitle,
    individualFirstName:
      individualRelationship === 'Spouse'
        ? { 'individual-firstName': spouseFirstname }
        : individualFirstName,
    individualMiddleName:
      individualRelationship === 'Spouse'
        ? { 'individual-middlename': spouseMiddleName }
        : individualMiddleName,
    individualLastName:
      individualRelationship === 'Spouse'
        ? { 'individual-lastname': spouseLastName }
        : individualLastName,
    individualSuffix: individualSuffix,
    individualDOB:
      individualRelationship === 'Spouse'
        ? { 'individual-dob': spouseDOB }
        : individualDOB,
    individualSSN:
      individualRelationship === 'Spouse'
        ? { 'individual-ssn': spouseSSN }
        : individualSSN,
    individualBirthPlace: individualBirthPlace,
    individualGender: individualGender,
    individualAddEmail: individualEmailList,
    individualAddPhone: individualPhoneList,
    individualaddressSection: individualaddressSection,
    individualDriverLicenseFields: individualDriverLicenseFields,
    entityQuestion: entityOptionValue,
    trustTypeOptions: trustType,
    companyNameSection,
    companyAuthorizedFields,
    companyAddressFields,
    companyContactDetailsFields,
    companyPhoneFields,
    partnershipSectionFields,
    partnerInfo: partners,
    partnershipAddressFields,
    partnershipContactDetailsFields,
    trusteeSection: trustee,
    beneficiaryFields: beneficiary,
    trustAgreementSection: trustAgreementFields,
    trustAgreementYesOptions: {
      'trustAgreement-yes-text': trustAgreementYesValue,
    },
    southDakotaQuestionFields: llcData,
    trustName,
  };
  useEffect(() => {
    dispatch({
      type: SET_SEND_DATA,
      payload: {
        payload: payload,
        sectionId: 'f1v1s4',
      },
    });
  }, [payload]);
  const onSaveFormDataHandler = () => {
    setShowDataSaveLoader(true);
    axios
      .post(`/rpiq-form-save/${localStorage.getItem('formId')}/f1v1s4`, payload)
      .then((response) => {
        showToastMessage(true);
        setShowDataSaveLoader(false);
        dispatch(policyOwnerAction());
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.detail === 'Not authenticated'
        ) {
          window.location.replace('/');
        }
        console.error('There was an error!', error);
        setShowDataSaveLoader(false);
      });
  };
  const onCloseToastMessage = () => {
    showToastMessage(false);
  };
  return (
    <>
      <CommonFormHeader
        backPath="/form/existinginsurance"
        nextPath="/form/foreignresidencyandfinancialinformation-policyownerindividual"
        pageHeading={poData?.metadata?.label}
        caseIdValue={poData?.common_details?.case_id}
        onSaveFormDataHandler={onSaveFormDataHandler}
        isCompleted={poData?.metadata?.isCompleted}
        sectionId="f1v1s4"
        userName={poData?.common_details?.name}
        productSubType={poData?.common_details?.product_subtype}
        formId={poData?.common_details?.form_id}
        otherCasesInfo={poData?.common_details?.other_cases}
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          {poData?.data && (
            <FormFieldsWrapper>
              <LabelRadioButtons
                label={questionSectionData.label}
                options={questionSectionData.options}
                onChangeHandler={poQuestionChangeHandler}
              />

              <div
                className={
                  poQuestion['poQuestion-no'] === hideFields
                    ? 'show-component'
                    : 'hide-component'
                }
              >
                <CommonLabelRadioButtons
                  options={noOptions}
                  onChangeHandler={noOptionsChangeHandler}
                />
                <div className="line-separation layout-1"></div>

                <div
                  className={
                    poQuestion['poQuestion-no'] === hideFields &&
                    noOptionValue['noOption-individual'] === 'individual'
                      ? 'show-component'
                      : 'hide-component'
                  }
                >
                  <IndividualSection
                    setIndividualEmailList={setIndividualEmailList}
                    individualEmailList={individualEmailList}
                    individualPhoneList={individualPhoneList}
                    setIndividualPhoneList={setIndividualPhoneList}
                    setIndividualTitle={setIndividualTitle}
                    setIndividualFirstName={setIndividualFirstName}
                    setIndividualMiddleName={setIndividualMiddleName}
                    setIndividualLastName={setIndividualLastName}
                    setIndividualSuffix={setIndividualSuffix}
                    setIndividualDOB={setIndividualDOB}
                    setIndividualSSN={setIndividualSSN}
                    setIndividualBirthPlace={setIndividualBirthPlace}
                    setIndividualGender={setIndividualGender}
                    setIndividualaddressSection={setIndividualaddressSection}
                    individualaddressSection={individualaddressSection}
                    setIndividualDriverLicenseFields={
                      setIndividualDriverLicenseFields
                    }
                    individualRelationship={individualRelationship}
                    setIndividualRelationship={setIndividualRelationship}
                    setSpouseFirstname={setSpouseFirstname}
                    setSpouseMiddleName={setSpouseMiddleName}
                    setSpouseLastName={setSpouseLastName}
                    setSpouseDOB={setSpouseDOB}
                    setSpouseSSN={setSpouseSSN}
                  />
                </div>

                <div
                  className={
                    poQuestion['poQuestion-no'] === hideFields &&
                    noOptionValue['noOption-entity'] === 'entity'
                      ? 'show-component'
                      : 'hide-component'
                  }
                >
                  <CommonLabelRadioButtons
                    options={entityOptions}
                    onChangeHandler={entityChangeHandler}
                  />
                  <div className="line-separation layout-1"></div>

                  <div
                    className={
                      poQuestion['poQuestion-no'] === hideFields &&
                      noOptionValue['noOption-entity'] === 'entity' &&
                      entityOptionValue['entityOption-trust'] === 'trust'
                        ? 'show-component'
                        : 'hide-component'
                    }
                  >
                    <TrustSection
                      trustAgreementFields={trustAgreementFields}
                      setTrustAgreementFields={setTrustAgreementFields}
                      trustee={trustee}
                      setTrustName={setTrustName}
                      setTrustee={setTrustee}
                      setTrustType={setTrustType}
                      setTrustAgreementYesValue={setTrustAgreementYesValue}
                      trustAgreementYesValue={trustAgreementYesValue}
                      beneficiary={beneficiary}
                      setBeneficiary={setBeneficiary}
                    />
                  </div>
                  <div
                    className={
                      poQuestion['poQuestion-no'] === hideFields &&
                      noOptionValue['noOption-entity'] === 'entity' &&
                      entityOptionValue['entityOption-llc'] === 'llc'
                        ? 'show-component'
                        : 'hide-component'
                    }
                  >
                    <LlcSection setLlcData={setLlcData} />
                  </div>

                  <div
                    className={
                      poQuestion['poQuestion-no'] === hideFields &&
                      noOptionValue['noOption-entity'] === 'entity' &&
                      entityOptionValue['entityOption-company'] === 'company'
                        ? 'show-component'
                        : 'hide-component'
                    }
                  >
                    <CompanySection
                      setCompanyNameSection={setCompanyNameSection}
                      setCompanyAuthorizedFields={setCompanyAuthorizedFields}
                      setCompanyAddressFields={setCompanyAddressFields}
                      setCompanyContactDetailsFields={
                        setCompanyContactDetailsFields
                      }
                      setCompanyPhoneFields={setCompanyPhoneFields}
                      companyPhoneFields={companyPhoneFields}
                    />
                  </div>

                  <div
                    className={
                      poQuestion['poQuestion-no'] === hideFields &&
                      noOptionValue['noOption-entity'] === 'entity' &&
                      entityOptionValue['entityOption-partnership'] ===
                        'partnership'
                        ? 'show-component'
                        : 'hide-component'
                    }
                  >
                    <PartnershipSection
                      setPartnershipSectionFields={setPartnershipSectionFields}
                      setPartnershipAddressFields={setPartnershipAddressFields}
                      setPartnershipContactDetailsFields={
                        setPartnershipContactDetailsFields
                      }
                      partners={partners}
                      setPartners={setPartners}
                    />
                  </div>
                </div>
              </div>
            </FormFieldsWrapper>
          )}
        </>
      )}
      {toastMessage === true && (
        <ToastMessage onCloseToastMessage={onCloseToastMessage} />
      )}
      {showDataSaveLoader && <Loader />}
    </>
  );
};

export default PolicyOwner;
